export enum WebShopType {
  OCI = 'OCI',
  IDS = 'IDS',
}
